import React from 'react';

// An AI-drafted answer for an employer-form question no record field covers
// (`employer_form.suggested`, staff only). It is a draft until a human saves it.
export default function SuggestionHint({ q, value }) {
  const s = q?.suggestion;
  if (!s?.answer) return null;
  if (s.confidence === 'low') {
    return <div className="text-xs text-muted-foreground">AI hint (low confidence): {s.answer}</div>;
  }
  if ((value || '') !== s.answer) return null;
  return <div className="text-xs text-[hsl(32_92%_28%)]">AI suggestion — check</div>;
}
